export enum TorrentStateStatusesEnum {
	added = "added",
	resuming = "resuming",
	checking = "checking",
	loading = "loading",
	downloading = "downloading",
	finished = "finished",
	seeding = "seeding"
}

export const torrentStateStatusesTranslates = {
	[TorrentStateStatusesEnum.added]: "torrent_status_added",
	[TorrentStateStatusesEnum.resuming]: "torrent_status_resuming",
	[TorrentStateStatusesEnum.checking]: "torrent_status_checking",
	[TorrentStateStatusesEnum.loading]: "torrent_status_loading",
	[TorrentStateStatusesEnum.downloading]: "torrent_status_downloading",
	[TorrentStateStatusesEnum.finished]: "torrent_status_finished",
	[TorrentStateStatusesEnum.seeding]: "torrent_status_seeding"
};
